import * as XLSX from 'xlsx';
import { I18N } from './i18n';
import { download, projectStem } from './exporters';
import { getPrices, findPrice } from './license';

// one entry per counting photo across the given reports
export function countEntries(reports) {
  const live = getPrices();
  return reports.flatMap((r) => r.photos.filter((p) => p.inventory && Object.keys(p.inventory).length).map((p) => {
    const items = Object.entries(p.inventory).map(([type, n]) => {
      const price = p.inventoryPrices?.[type] ?? findPrice(live, type);
      return { type, n, price: price ?? null, amount: price != null ? n * price : null };
    });
    return { id: p.id, rid: r.id, report: r.title, date: p.createdAt, thumb: p.data, items, total: items.reduce((s, i) => s + (i.amount || 0), 0) };
  }));
}

export function countTotals(entries) {
  const by = {};
  entries.forEach((e) => e.items.forEach((i) => {
    const k = i.type;
    by[k] = by[k] || { type: k, n: 0, amount: 0, price: i.price, priced: false };
    by[k].n += i.n;
    if (i.amount != null) { by[k].amount += i.amount; by[k].priced = true; }
  }));
  const rows = Object.values(by).sort((a, b) => b.n - a.n);
  return { rows, total: rows.reduce((s, r) => s + r.amount, 0), pieces: rows.reduce((s, r) => s + r.n, 0) };
}

const r2 = (v) => (v == null ? '' : Math.round(v * 100) / 100);

export function exportCountsXLSX(project, lang) {
  const t = I18N[lang] || I18N.de;
  const entries = countEntries(project.reports);
  const { rows, total } = countTotals(entries);
  const loc = t.locale;
  const detail = [[project.title], [], ['#', t.reports, t.histDate, t.colType, t.colCount, t.colUnitPrice, t.colAmount]];
  entries.forEach((e, i) => e.items.forEach((it) => detail.push([i + 1, e.report, new Date(e.date).toLocaleString(loc), it.type, it.n, r2(it.price), r2(it.amount)])));
  const sum = [[project.title], [], [t.colType, t.colCount, t.colUnitPrice, t.colAmount],
    ...rows.map((r) => [r.type, r.n, r2(r.price), r.priced ? r2(r.amount) : '']), [], [t.invSum, '', '', r2(total)]];
  const wb = XLSX.utils.book_new();
  const add = (aoa, name, w) => { const ws = XLSX.utils.aoa_to_sheet(aoa); ws['!cols'] = w.map((wch) => ({ wch })); XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31)); };
  add(detail, t.histSheetDetail, [5, 30, 20, 24, 10, 14, 14]);
  add(sum, t.histSheetSum, [28, 10, 14, 14]);
  wb.Props = { Title: project.title, Author: 'GISS FieldRapport Pro', Company: 'GISS - Software Solutions' };
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const base = projectStem(project);
  download(new Blob([out], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${base}_Materialzaehlungen.xlsx`);
}
